module.exports = __webpack_public_path__ + "assets/84925bf1b62f53b7c3cbd599520e9dd3.wav";